import { KeyedMutator } from 'swr';
import { invalidateStartsWith } from 'hooks/useSWR';
import { useShortlists } from 'apis/CompanyAPI/users/useShortlists';
import { userAPIUrls } from 'apis/CompanyAPI/users/usersApi';
import { List } from 'types/api';
import { Shortlist } from 'types/user';

export function invalidateCollectionCompanies() {
  // Covers the companies in the lists and the suggestions, which leave out companies already in a list
  invalidateStartsWith([`${userAPIUrls.shortlists.list()}/`]);
}

/** The user's lists, where changing a list also refreshes the companies and suggestions shown on the page. */
export default function useCollectionShortlists() {
  const { resource, mutate } = useShortlists();

  const setShortlists: KeyedMutator<List<Shortlist>> = async (...args) => {
    const result = await mutate(...args);
    invalidateCollectionCompanies();
    return result;
  };

  return { resource, setShortlists };
}
